export default __webpack_public_path__ + "static/media/YoungEntrepreneurs3.37ad744e.JPG";